import React from "react";
import { Icons } from "../../shared/Icons";

interface BudgetPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export const BudgetPagination: React.FC<BudgetPaginationProps> = ({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  disabled = false,
}) => {
  if (total <= pageSize) {
    return null;
  }

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-3 px-1">
      <p className="text-sm text-gray-600">
        Mostrando <span className="font-medium text-gray-900">{start}</span>–
        <span className="font-medium text-gray-900">{end}</span> de{" "}
        <span className="font-medium text-gray-900">{total}</span> orçamentos
      </p>

      <div className="flex items-center gap-2">
        <button
          type="button"
          disabled={disabled || page <= 1}
          onClick={() => onPageChange(page - 1)}
          className="inline-flex items-center gap-1 px-3 py-2 text-sm font-medium border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Página anterior"
        >
          <Icons.ChevronLeft sx={{ fontSize: 18 }} />
          Anterior
        </button>

        <span className="text-sm text-gray-600 min-w-[7rem] text-center">
          Página {page} de {totalPages}
        </span>

        <button
          type="button"
          disabled={disabled || page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          className="inline-flex items-center gap-1 px-3 py-2 text-sm font-medium border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          aria-label="Próxima página"
        >
          Próxima
          <Icons.ChevronRight sx={{ fontSize: 18 }} />
        </button>
      </div>
    </div>
  );
};
